import React from 'react';
import { FiShoppingBag } from 'react-icons/fi';

const Loader = ({ fullPage = true }) => {
  return (
    <div className={`flex flex-col items-center justify-center ${fullPage ? 'min-h-[60vh]' : 'p-8'} gap-4`}>
      <div className="relative">
        {/* Glowing Background */}
        <div className="absolute inset-0 bg-[#ff7a00]/20 blur-xl rounded-full animate-pulse" />
        
        {/* Animated Handbag */}
        <div className="relative animate-bounce duration-1000">
          <FiShoppingBag size={48} className="text-[#ff7a00] filter drop-shadow-lg" />
        </div>
        
        {/* Loading Ring */}
        <div className="absolute -inset-2 border-2 border-transparent border-t-[#ff7a00]/30 border-r-[#ff7a00]/30 rounded-full animate-spin duration-[2000ms]" />
      </div>
      
      {/* Text with high tracking as per Apple aesthetic */}
      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.4em] animate-pulse">
        Establishing Context
      </p>
    </div>
  );
};

export default Loader;
